/* store.js — carousel, drawers, hero mute (card ATC owned by alkaram-style.js) */

document.addEventListener("DOMContentLoaded", () => {
  /* ---------- Carousel arrows ---------- */
  document.querySelectorAll(".arrow").forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = document.getElementById(btn.dataset.target);
      if (!target) return;
      const dir = btn.classList.contains("next") ? 1 : -1;
      target.scrollBy({ left: dir * 560, behavior: "smooth" });
    });
  });

  /* ---------- Mobile drawer ---------- */
  const drawer = document.getElementById("drawer");
  const scrim = document.getElementById("scrim");
  const openBtn = document.getElementById("drawerOpen");
  const closeBtn = document.getElementById("drawerClose");
  const closeDrawer = () => {
    drawer?.classList.remove("open");
    scrim?.classList.remove("open");
  };
  openBtn?.addEventListener("click", () => {
    drawer?.classList.add("open");
    scrim?.classList.add("open");
  });
  closeBtn?.addEventListener("click", closeDrawer);
  scrim?.addEventListener("click", closeDrawer);

  /* ---------- Mute/unmute for hero videos ---------- */
  document.querySelectorAll("[data-mute-toggle]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const video = btn.closest(".dual-panel")?.querySelector("video");
      if (!video) return;
      video.muted = !video.muted;
      btn.textContent = video.muted ? "Unmute" : "Mute";
    });
  });
});
